export const getApiErrorMessage = (error, fallbackMessage = "An unexpected error occurred") => {
  const payload = error?.response?.data;
  const payloadErrors = payload?.errors;

  if (typeof payloadErrors === "string" && payloadErrors.trim()) {
    return payloadErrors;
  }

  if (Array.isArray(payloadErrors)) {
    const messages = payloadErrors
      .map((item) => item?.message)
      .filter((message) => typeof message === "string" && message.trim());

    if (messages.length > 0) {
      return messages.join(", ");
    }
  }

  if (payloadErrors && typeof payloadErrors === "object") {
    if (typeof payloadErrors.message === "string" && payloadErrors.message.trim()) {
      return payloadErrors.message;
    }

    if (typeof payloadErrors.detail === "string" && payloadErrors.detail.trim()) {
      return payloadErrors.detail;
    }
  }

  if (typeof payload?.message === "string" && payload.message.trim()) {
    return payload.message;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallbackMessage;
};
